import "@babel/polyfill";
import 'slick-carousel';
import 'air-datepicker';

import Tools from './_tools';
import faqInit from '../../blocks/project/b-faq/b-faq'
import Countdown from '../../blocks/project/b-countdown/b-countdown'
import platesSliderInit from '../../blocks/project/b-plates-slider/b-plates-slider'
import popupsInit from '../../blocks/project/b-popup/b-popup'
import headerInit from '../../blocks/project/b-header/b-header'
import InputText from '../../blocks/project/b-input-text/b-input-text'
import RatingStars from '../../blocks/project/b-rating-stars/b-rating-stars'
import videoInit from '../../blocks/project/b-video/b-video'
import ServiceCalc from '../../blocks/project/b-service-calc/b-service-calc'
import SittersCarousel from '../../blocks/project/b-sitters-carousel/b-sitters-carousel'
import {patronageFeaturesInit} from "../../blocks/project/b-patronage-features/b-patronage-features";
import {additionalServicesInit} from "../../blocks/project/b-additional-services/b-additional-services";


$(document).ready(() => {
    Tools.initSelect2();
    faqInit();
    Countdown.init();
    platesSliderInit();
    popupsInit();
    headerInit();
    InputText.init();
    RatingStars.init();
    Tools.initYouTubeApi();
    videoInit();
    ServiceCalc.init();
    SittersCarousel.init();
    patronageFeaturesInit();
    additionalServicesInit();
});